<div class="p-3">
  <p class="h3 text-secondary" mat-dialog-title>Confirmar</p>
  <mat-dialog-content>Deseja realmente sair do sistema?</mat-dialog-content>
  <mat-dialog-actions class="d-flex justify-content-between">
    <app-button buttonClass="bt-default" mat-button mat-dialog-close>Fechar</app-button>
    <app-button buttonClass="bt-danger" (clicked)="logOut()" mat-button mat-dialog-close>Sim</app-button>
  </mat-dialog-actions>
</div>
